import axios from "axios";
import config from "@/router/globalConfig";

export default {
    //Get Services axois
    getMasterType(_data_) {
        return axios.get(config.WEB_API_PATH + 'Master/GetMasterType', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    getRank(_data_) {
        return axios.get(config.WEB_API_PATH + 'Master/GetRank', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    getUserType(_data_) {
        return axios.get(config.WEB_API_PATH + 'Master/GetUserType', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    getBookingForUnit(_data_) {
        return axios.get(config.WEB_API_PATH + 'Master/GetBookingForUnit', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    getBookingTypes(_data_) {
        return axios.get(config.WEB_API_PATH + 'Master/GetBookingTypes', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    getPersonAgeGroupType(_data_) {
        return axios.get(config.WEB_API_PATH + 'Master/GetPersonAgeGroupType', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    getPersonAgeGroup(_data_) {
        return axios.get(config.WEB_API_PATH + 'Master/GetPersonAgeGroup', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    //Post Services axois
    setRank(_data_) {
        return axios.post(config.WEB_API_PATH + 'Master/SetRank', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    setUserType(_data_) {
        return axios.post(config.WEB_API_PATH + 'Master/SetUserType', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    setBookingType(_data_) {
        return axios.post(config.WEB_API_PATH + 'Master/SetBookingType', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    setPersonAgeGroup(_data_) {
        return axios.post(config.WEB_API_PATH + 'Master/SetPersonAgeGroup', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
}


// WEBPACK FOOTER //
// ./src/components/servicesJS/MasterEntry.js